import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Table, Button, ButtonGroup, Input, Card, CardBody, Breadcrumb, BreadcrumbItem, Nav, NavItem, TabContent, TabPane, Row, Col } from "reactstrap";
import moment from 'moment';
import { renderToString } from 'react-dom/server';

import CustomSwitch from '../../custom/CustomSwitch';
import GenerateCertificate from './GenerateCertificate';
import ReactTable from '../../custom/ReactTable';
import { extractReactTableData, fileDownload } from '../../../utils';
import apiClient from '../../../apiClient';
import Select from '../../Select';
import styled from 'styled-components';
import _ from 'lodash';
import ActionIcon from '../../custom/ActionIcon';
import VirtualTable from '../../custom/VirtualTable';

const Quizzes = () => {

    const [quizData, setQuizData] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [enableFilterPassing, setEnableFilterPassing] = useState(false);
    const [unitFilter, setUnitFilter] = useState(null);
    const [modules, setModules] = useState([]);
    const [selectedModule, setSelectedModule] = useState(null);
    const reactTableRef = useRef();

    const selectAllQuizRecords = () => {
        apiClient.get(`/selectAllQuizRecords`).then(response => {
            setQuizData(response.data);
            setDisplayData(response.data);
            setModules(resolveModules(response.data));
        }).catch(error => {
            alert(error);
        });
    }

    useEffect(() => {
        selectAllQuizRecords();
    }, []);

    const filterPassing = () => {
        const data = quizData.filter(d => d.b_completed);
        setDisplayData(data);
    }

    useEffect(() => {
        if (enableFilterPassing) {
            filterPassing();
        } else {
            setDisplayData(quizData);
        }
    }, [enableFilterPassing]);

    const resolveModules = (data) => {
        const modules = [];
        for (let i = 0; i < data.length; i++) {
            const add = {
                module_id: data[i].module_id,
                module_name: data[i].module_name
            }

            const foundIndex = modules.findIndex(m => m.module_id === add.module_id);

            if (foundIndex === -1) {
                modules.push(add);
            }
        }
        return modules;
    }

    const filterByUnit = (value, reset) => {
        let filtered;

        const useData = enableFilterPassing ?
            quizData.filter(d => d.b_completed) :
            quizData;

        if (unitFilter === value) {
            if (!reset) {
                setUnitFilter(null);
            }
            filtered = useData;
        } else {
            setUnitFilter(value);
            if (quizData && quizData.length > 0) {
                filtered = useData.filter(d => d && d.s_unit && d.s_unit.toLowerCase() === value.toLowerCase());
            }
        }

        setDisplayData(filtered);
    }

    const filterByModule = (value) => {
        const module = modules.find(item => item.module_id == value);

        if (!module) return;

        if (selectedModule && selectedModule.module_id === module.module_id) {
            setSelectedModule(null);
            filterByUnit(unitFilter, true);
        } else {
            setSelectedModule(module);
            const filtered = displayData.filter(d => d.module_id === module.module_id);
            setDisplayData(filtered);
        }
    }

    const getQuizFileData = (s_quiz_file_name) => {
        apiClient.post(`/getQuizFileData`, {
            s_quiz_file_name
        }).then(response => {
            const myWindow = window.open("", "MsgWindow", "width=1920,height=1080");
            myWindow.document.write(response.data);
        }).catch(error => {
            alert(error);
        });
    }

    const selectQuizData = (training_record_id) => {
        apiClient.post(`/selectQuizData`, {
            id: training_record_id
        }).then(response => {
            const { quizData, stationInfo } = response.data;

            const certificate = renderToString(
                <GenerateCertificate
                    quizData={quizData}
                    stationInfo={stationInfo}
                />
            );

            const myWindow = window.open("", "MsgWindow", "width=1920,height=1080");
            myWindow.document.write(certificate);
        }).catch(error => {
            alert(error);
        });
    }

    const trainingRecordCsv = () => {
        const schema = [{
            key: 's_unit',
            name: 'Station'
        }, {
            key: 'displayName',
            name: 'User'
        }, {
            key: 'jobTitle',
            name: 'Title'
        }, {
            key: 'module_name',
            name: 'Module'
        }, {
            key: 'b_completed',
            name: 'Passed',
            boolean: true
        }, {
            key: 't_completed',
            name: 'Date',
            datetime: true
        }, {
            key: 's_instructor',
            name: 'Trainer'
        }, {
            key: 'f_percent',
            name: 'Score',
            percent: true
        }];

        const data = extractReactTableData(reactTableRef, [], schema);

        fileDownload(data, 'Training Data.csv');
    }

    return (
        <Row>

            <Col md={12} className={'mb-2'}>
                <Card className='custom-opacity-card' style={{ borderRadius: '0.75rem' }}>
                    <CardBody className='custom-card-transparent py-3 px-5' style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                        <FlexContainer>
                            <CustomSwitch
                                label={'Show Only Passing'}
                                value={enableFilterPassing}
                                handleSwitch={setEnableFilterPassing}
                            />
                            <Row>
                                WARNING: This record contains Sensitive Security Information that is controlled under 49 CFR parts 15 and 1520. No part of this record may be disclosed to persons without a "need to know", as defined in 49 CFR parts 15 and 1520, except with the written permission of the Administrator of the Transportation Security Administration or the Secretary of Transportation. Unauthorized release may result in civil penalty or other action. For U.S. government agencies, public disclosure is governed by 5 U.S.C. 552 and 49 CFR parts 15 and 1520.
                            </Row>
                        </FlexContainer>
                    </CardBody>
                </Card>
            </Col>

            <Col md={12}>
                <Card className='custom-opacity-card' style={{ borderRadius: '0.75rem' }}>
                    <CardBody className='custom-card-transparent py-3 px-5' style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                        <Row>
                            <Col md={12}>
                                <FlexContainer>
                                    <h4>Records:</h4>
                                    <ActionIcon
                                        type={'csv'}
                                        onClick={trainingRecordCsv}
                                    />
                                </FlexContainer>
                                <VirtualTable
                                    reactTableRef={reactTableRef}
                                    data={displayData}
                                    mapping={[
                                        {
                                            name: 'Module',
                                            value: 'module_name'
                                        },
                                        {
                                            name: 'User',
                                            value: 'displayName'
                                        },
                                        {
                                            name: 'Title',
                                            value: 'jobTitle'
                                        },
                                        {
                                            name: 'Completed',
                                            value: 'b_completed',
                                            boolean: true
                                        },
                                        {
                                            name: 'Date',
                                            value: 't_completed',
                                            datetime: true,
                                            utc: true
                                        },
                                        {
                                            name: 'Score',
                                            value: 'f_percent',
                                            percent: true
                                        },
                                        {
                                            name: 'Instructor',
                                            value: 's_instructor',
                                        },
                                        {
                                            name: 'Unit',
                                            value: 's_unit'
                                        },
                                        {
                                            name: '',
                                            value: 'fas fa-file-download',
                                            icon: true,
                                            function: (item) => getQuizFileData(item.s_quiz_file_name)
                                        },
                                        {
                                            name: '',
                                            value: 'fas fa-certificate',
                                            icon: true,
                                            showCondition: (item) => item.b_completed,
                                            function: (item) => selectQuizData(item.training_record_id)
                                        }
                                    ]}
                                    index={true}
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>

        </Row>
    );
}

export default Quizzes;


const FlexContainer = styled.div`
    display: flex;
    gap: 25px;
    align-items: center;
    justify-content: space-between;
`;